import EventBus from "./eventBus";
import router from "@/router/router";
// import store from "@/store";
import store from "@/store/index";
import {errorLog} from "@/api/login";

window.addEventListener('offline', function (e) {
  alert('网络不太好，请检查网络并刷新')
})
// window.addEventListener('online', function(e) {alert('online')})
export default {
  bindTryTimes: 5,
  bound: false,
  ws: "",
  interval: '',
  startWs() {
    //启动websocket
    if (this.ws){
      this.ws.close()
    }
      var ws = new WebSocket(process.env.VUE_APP_DATA_WS_URL);
    this.ws = ws;
    ws.onopen = () => {
      // this.sendBindBubbleMessage();
      //admin , worker , store , dispatch 0管理员 1门店 2派单员 3司机
      let name = JSON.parse(localStorage.getItem("userInfo"))?.type;
      this.ws.send(
        JSON.stringify({
          type: "bind",
          token: localStorage.getItem("token"),
          name:
            name == 0
              ? "admin"
              : name == 1
                ? "store"
                : name == 2
                  ? "dispatch"
                  : "worker",
        })
      );
      this.bindTryTimes = 5
    };
    ws.onmessage = (message) => {
      let data = message.data;
      try {
        data = JSON.parse(data);
      } catch (e) {
        //
      }
      this.handleWsMessage(data);
    };
    ws.onerror = (e) => {
      clearInterval(this.interval)
      this.sendBindBubbleMessage()
    };
    ws.onclose = () => {
      this.ws = null;
      clearInterval(this.interval)
      // this.sendBindBubbleMessage()
    };
  },
  disconnect() {
      this.ws.close();
  },
  sendBindBubbleMessage() {
    this.bindTryTimes--;
    if (this.bindTryTimes < 0) {
      //重试五次,结束
      alert("Connection failed!");
      // this.ws.close();
      this.ws = null;
      // this.ws = null;
      this.logout();
      return;
    }
    this.$WebSocket.startWs()
    setTimeout(() => {
      //5秒后重试
      this.sendBindBubbleMessage();
    }, 5000);
  },
  handleWsMessage(message) {
    let name = JSON.parse(localStorage.getItem("userInfo")).type;
    if (message.type === "onBind") {
      // 每三分钟发送一条消息
      this.interval = setInterval(() => {
        var time = new Date()
        this.ws.send(
          JSON.stringify({
            uid: name,
            client_id: message.client_id,
            Ip: localStorage.getItem('Ip'),
            type: 'heartbeat',
            time: time.toLocaleString(),
          })
        );
        let time_save = localStorage.getItem('time_save')
        if (time_save) {
          localStorage.removeItem('time_save')
        }
        localStorage.setItem('time_save', time)


      }, 60 * 1000); // 1分钟
    }
    if (message.type == 'onHeartbeat') {
      const givenTime = localStorage.getItem('time_save');
      const givenTimes = new Date(givenTime)
      const currentTime = new Date();

      // 计算时间差（以毫秒为单位）
      const timeDiffMs = Math.abs(currentTime - givenTimes);
      if (timeDiffMs > 2 * 60 * 1000) {
        let time = new Date()
        errorLog({
          uid: name,
          client_id: message.client_id,
          Ip: localStorage.getItem('Ip'),
          type: 'heartbeat',
          time: time.toLocaleString(),
          timestamp: timeDiffMs,
          error_msg: '超时',
        }).then(res => {

        })
      }
    }
    if (message.count) {
      //数据返回成功
      this.handleBubbleMessage(message);
    }
    if (message.type == "workerMapData") {
      // console.log('--WS--司机完成了一个任务--司机地图-',message)
      // EventBus.$emit('onBindDriverMap',message)
      this.bound = true; //ws.bound
      store.commit("driverFinishTaskAtMap", message);
    } else {
      this.handleDispatchMes(message);
    }
    if (message.type == "unassigned_count") {
      EventBus.$emit('unassignedCount', message.count)
    }

    if (message.type == 'power_change') {
      // console.log('--你的权限变了-要重新登录--')
      // alert('你的权限变了请重新登录！')
      store.commit("changeGlobalDialogStatus", true);
      localStorage.removeItem("token");
      this.logout();
    }
    if (message.type == 'delay_task') {
      // console.log('延迟预警....')
      store.commit("updateDelayTask", message);
    }
  },
  handleBubbleMessage(data) {
    // EventBus.$emit("bubble", data.count);
  },
  handleDispatchMes(message) {
    if (message[0]) {
      if (message[0].forward == "task") {
        message.forEach((v) => {
          store.commit("changeTaskHandle", v);
        });
      }
    } else {
      //司机上线下线
      if (message.forward == "workerStatus") {
        // console.log("司机上线下线");
        // 这里需要向司机地图传送 司机上下线
        EventBus.$emit('updateDriverMapStatus', message)
        store.commit("updateDriverStatus", message);
      }
      if (message.forward == "workerPoint") {
        //更新司机点
        store.commit('changeDriverPoint', message)
      }
      //接收新消息
      if (message.type == "sendMsg") {
        store.commit("newMess", message);
      }
      //workerTransfer 司机点击任务开始或者任务完成时候 收到的消息
      if (message.forward == "workerTransfer") {
        store.commit("updateDriverStatus", message);
      }
      if (message.forward_type == 7) {
        store.commit("changeTaskHandle", message);
      }
      if (message.forward == "taskSort") {
        store.commit("sortTreeList", message);
      }
    }
  },
  logout() {
    router.push("/login");
  },
};
